import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { Footer, Header } from "./components";
import { useTenantImage } from "@ploy-ui/tenants";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Box } from "@material-ui/core";
import { ImageFit } from "@ploy-ui/core";
const LoginWrapper = (props) => {
    const loginBackground = useTenantImage("loginBackground");
    const loginInternalBackground = useTenantImage("loginInternalBackground");
    const { classes, footerVisible, elevation = loginBackground ? 2 : 0, children, isInternal, } = props;
    const headerVisible = !loginBackground;
    return (_jsxs(LoginBackground, { image: isInternal ? loginInternalBackground : loginBackground, className: classes?.root, children: [headerVisible && _jsx(Header, {}), _jsx(Box, { display: "flex", alignItems: headerVisible ? "flex-start" : "center", className: classes?.formWrapper, children: _jsx(Paper, { elevation: elevation, className: classes?.form, children: children }) }), footerVisible && _jsx(Footer, {})] }));
};
const useStyles = makeStyles({
    root: {
        height: "100vh",
        top: 0,
        resize: "both"
    }
});
function LoginBackground(props) {
    const { image, className, children } = props;
    const classes = useStyles(props);
    return (_jsx(ImageFit, { src: image, fit: "cover", className: clsx(classes.root, className), children: children }));
}
export { LoginWrapper };
//# sourceMappingURL=LoginWrapper.js.map